module.exports = __webpack_public_path__ + "img/collaborate-right-jewelry-path-2.fa711c2e.svg";